import { NotificationsResponseModel } from '../types/NotificationModels';
import { api } from './api';

export const getNotifications = async (
  token: string,
  skip: number,
  size: number
): Promise<NotificationsResponseModel> => {
  try {
    const response = await api.get<NotificationsResponseModel>(
      `/v1/notification`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          skip,
          size,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};
